export function validateIsVendorSick(vendor?: string): boolean {
  if (!vendor) {
    return false;
  }
  return /^SICK(\sAG)?$/i.test(vendor);
}
